const ID_TOKEN_KEY = "id_token";

const inIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

// Every tenant's iframe shares one origin, so localStorage would hand tenant B's
// token to tenant A's tab (CONNECT-7420). Inside the host the handshake delivers
// a fresh token on every load anyway.
let memoryToken = null;

export const getToken = () => {
  return inIframe ? memoryToken : window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = token => {
  if (inIframe) {
    memoryToken = token;
    return;
  }
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
  if (inIframe) {
    memoryToken = null;
    return;
  }
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
